import React from 'react';
import {GetPrograms} from "../../api";
import FetchOptionsSelect from "./FetshOptionsSelect";
import {useTranslation} from "react-i18next";

const ProgramsSelect = ({onChange, defaultFetchOptionIds}) => {

    const { t } = useTranslation();
    const formatProgramOptions = (response) => {
        return response.data.map(fetchOption => ({
            value: fetchOption.id,
            label: fetchOption.name
        }))
    }
    return <FetchOptionsSelect
        onChange={onChange}
        fetchOptionsFunction={GetPrograms}
        loadingPlaceholder={t("Loading Programs...")}
        placeholderText={t("Select Program")}
        defaultFetchOptionIds={defaultFetchOptionIds}
        formatFetchOptionsFunction={formatProgramOptions}  />

};

export default ProgramsSelect;
